import React from 'react';
import PropTypes from 'prop-types';
import { Permissions } from '@upstart/harmony/lib/constants';
import { SplitButton } from 'react-bootstrap/lib';
import DeleteButton from './DeleteButton';
import withFeedPermission from './feedPermission';

function EditButton({ feed, onEdit, onDelete }) {
  return (
    <div>
      <SplitButton
        title="Edit"
        key={feed.id}
        id={`split-button-basic-${feed.id}`}
        onClick={() => {
          onEdit(feed.id);
        }}
      >
        <DeleteButton feed={feed} onDelete={onDelete} />
      </SplitButton>
    </div>
  );
}

EditButton.propTypes = {
  feed: PropTypes.object,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
};

export default withFeedPermission(Permissions.UPDATE)(EditButton);
